export const FACEBOOK_CONNECTED_TOGGLE = "FACEBOOK_CONNECTED_TOGGLE"



// WEBPACK FOOTER //
// ./src/types/actions/facebookConnectedDialog.js